<template>
  <ul :class="`image-list ${classes}`">
    <li v-for="(item, index) in items" :key="index">
      <h2 v-if="item.heading" v-html="item.heading"></h2>
      <img :src="item.src" :alt="item.alt || '...'" :style="`height:${item.height || '100%'}`" :class="item.class || ''" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PopupImageList',
  props: {
    classes: {
      type: String,
      required: false,
      default: '',
    },
    items: {
      type: Array,
      required: true,
    }
  },
}
</script>
